import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import Description from "./Description";

const Descriptions = withLiteObserverAndTheme<{
  userID: number;
  selfDescriptionId: number;
  selfDescriptionStatus: string;
  selfDescription: string;
  selfDescriptionAlignment: "left" | "right";
  peerDescriptionId: number;
  peerDescriptionStatus: string;
  peerDescription: string;
  peerDescriptionAlignment: "left" | "right";
}>((props) => {
  const {
    theme,
    userID,
    selfDescriptionId,
    selfDescriptionStatus,
    selfDescription,
    selfDescriptionAlignment,
    peerDescriptionId,
    peerDescriptionStatus,
    peerDescription,
    peerDescriptionAlignment
  } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={900}
      height={310}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Description
        userID={userID}
        descriptionStatus={selfDescriptionStatus}
        descriptionId={selfDescriptionId}
        descriptionType="self_description"
        description={selfDescription}
        descriptionAlignment={selfDescriptionAlignment}
      />
      <Et3Margin left={25} right={25} bottom={0} top={0} />
      <Description
        userID={userID}
        descriptionStatus={peerDescriptionStatus}
        descriptionId={peerDescriptionId}
        descriptionType="peer_description"
        description={peerDescription}
        descriptionAlignment={peerDescriptionAlignment}
      />
    </ET3Div>
  );
});

export default Descriptions;
